__webpack_require__.p = "/dev/delete-httpclient-piece-ts/";